// ====================================================================
// ziven-geewen-site forum webpack entry
// ====================================================================
//
// flarum-webpack-config 找 process.cwd() 下的 forum.{js,ts} / admin.{js,ts}
// 作为 webpack entry.
// ====================================================================

// Forum module
import './src/forum/index.js';

// Default export for compatibility
export default {};
